export default __webpack_public_path__ + "static/media/pantry2-before1-2048w.5d8e889b.avif";